<template>
  <div>
    <el-dialog
      :visible.sync="$root.agreeVisible"
      width="840px"
      :before-close="close"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="container">
        <div class="box">
          <i class="iconfont icon-guanbi" @click="close" />
          <ul class="tab">
            <li class="on">老子云用户协议</li>
          </ul>
          <div class="ct-box" id="ctBox" ref="ctBox">
            <ul class="ct">
              <li>欢迎使用老子云！</li>
              <li>
                为使用老子云服务（可简称“本服务”），您应当阅读并遵守《老子云服务协议》（以下简称:本协议）。请您务必审慎阅读、充分理解各条款内容，特别是
                限制或免除责任的条款，以及开通或使用某项服务的单独协议、规则。限制或免责条款可能以加粗或加下划线的形式提示您重点注意。
              </li>
              <li>
                除非您已阅读并接受本协议及相关协议、规则等的所有条款，否则，您无权使用本服务。一旦您选择“同意协议并提交”（具体措辞详见注册页面）并完成
                注册流程，或您以任何方式使用本服务，即视为您已阅读并同意上述协议、规则等的约束。
              </li>
              <li>
                您有违反本协议的任何行为时，老子云有权依照本协议根据您违反情况，随时单方采取限制、中止或终止向您提供服务等措施，并有权追究您的相关责任。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第一条 通则</li>
              <li>
                1.1
                老子云服务指为满足各类网站、应用等各种产品/服务的不同需求，由计算处理与网络、存储与
                CDN、云数据库、云安全、监控与管理、域名服务、
              </li>
              <li>
                1.2
                老子云服务的种类、服务标准、使用规则、结算方式（包括但不限于预付费、后付费等，下同）及计费标准等统称“服务规则”，以老子云官网（网址：
                www.laozicloud.com，下同）及购买具体服务时的页面说明为准，本协议或双方另有约定除外。
              </li>
              <li>
                1.3
                眸瑞公司有权随时对老子云服务规则进行调整，并通过网站公告、邮件通知、短信通知等方式予以公布，而无需另行获得您同意。
              </li>
              <li>
                1.4
                眸瑞公司仅向您提供基于计算机的云系统算力服务等各类技术服务，是中立的信息存储空间等网络服务及相关的中立技术支持服务提供者(具体服务请
                参阅网站介绍内相关页面)。您的网站、应用等任何产品、服务及相关内容等，由您自行开发、运营，且自行承担全部责任。
              </li>
              <li>
                1.5
                双方均保证已经依照国家相关规定获得了合法经营资质，有权依法运营其产品及服务。您应按国家及地方要求对接入网站进行备案，否则，眸瑞公司有
                权根据国家法律法规拒绝提供网络接入等服务。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第二条 账户</li>
              <li>
                2.1
                您可以使用手机号码等老子云服务支持的方式，按照老子云官网注册页面提示完成注册流程，并获得老子云服务账户（简称“老子云账户”）。
              </li>
              <li>
                2.2
                您若使用关联帐号注册，为保护老子云账户的安全性和独立性，您应当在注册过程中关联手机号码，以用于老子云服务的相关操作。
              </li>
              <li>
                2.3
                您应当按照老子云服务注册流程填写、提交真实、合法、有效的资料（统称“资料”），根据您对产品及服务的需求，包括但不限于名称、联系人、电子
                邮箱、联系电话、联系地址、工商登记证件等；如果资料发生变更的，您应及时根据老子云系统的规则自行进行更新。
              </li>
              <li>
                2.4
                本协议效力适用于您名下全部老子云账户。老子云账户将作为您使用老子云服务的身份识别依据，您应当对老子云账户采取必要、有效的保密措施，并
                为您老子云账户下的一切行为负责。
              </li>
              <li>
                2.5
                为保护账户和交易安全，眸瑞公司有权随时要求您进行实名认证，您应当予以配合。您同意授权眸瑞公司可以通过向第三方核实您的身份和资格等信息
                的方式，对您进行认证及取得您使用本服务所需的相关资料。
              </li>
              <li>
                2.6
                实名认证是对老子云账号归属进行判断的一个依据，且账户申请提现及获取发票时将以实名认证对应的主体为准，请您在做认证时务必谨慎对待，给与
                足够的重视并理解、遵守以下规则：
                <p>
                  2.6.1
                  须确保认证主体与账号使用主体保持一致，避免将企业使用的账户认证在个人名下，或将本人使用的老子云账户认证在他人名下等任何不当认证行为。
                </p>
                <p>
                  2.6.2
                  若企业因自身经营需要，将其以企业名义认证的老子云账户交由个人管理的，请做好权限管控，并且在遇到人员变动时请及时完成内部交接和账号安
                  全保护（比如更改登录密码等）。
                </p>
                <p>
                  2.6.3
                  实名认证主体将被视为承诺对账号下的一切行为负责，若账号或账号下行为出现纠纷时（包括但不限于实施违法违规行为、逾期支付服务费等），需
                  由实名认证主体承担全部责任。
                </p>
                <p>
                  2.6.4
                  您需自行建立健全内部管理制度，规范自身对老子云账户的使用与管理。
                </p>
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第三条 服务规则</li>
              <li>
                3.1 服务开通
                <p>
                  3.1.1
                  您可根据自身需求，自行通过老子云官网在线选购或免费使用所需相关服务，购买前请您仔细阅读所购服务对应的服务规则并根据自身需求决定是否购买。
                  您在线选购服务产生的订单即为“电子订单”，双方也可根据实际合作需要，另行签订《老子云标准服务订单》（简称“纸质订单”）、《补充协议》等文件。
                </p>
                <p>
                  3.1.2
                  部分老子云服务的开通可能需要双方另行签订单独的服务协议，单独的服务协议可能以电子文档形式展示，也可能是独立的纸质文档形式展示，您可以根据自身情况决定是否接受服务协议及开通服务。
                </p>
              </li>
              <li>
                3.2 服务费用
                <p>
                  3.2.1
                  老子云服务结算方式、计费标准以老子云官网公布价格为准，以人民币计算，双方另有约定的除外。
                </p>
                <p>
                  3.2.2
                  老子云服务的结算规则可能分为预付费和后付费等类型，您应当遵守您选购的服务的结算规则，否则，会导致您开通的服务被中止、终止。
                  采用预付费规则的服务，您需及时向老子云账户充值，以保证顺利使用服务。采用后付费规则的服务，您需在服务规则指定的期限内及时支付费用。
                </p>
                <p>
                  3.2.3
                  本协议项下的业务发生销售折让、销售退回或其它按照国家规定需要开具红字发票或重新开票的情况，眸瑞公司需按照国家税收规定向您开具红字发票或重新开票，
                  您需按照国家税收规定退回已开具的发票或向税局递交需眸瑞公司开具红字专用发票的有效证明。双方约定具体按以下政策执行：
                </p>
                <p>
                  &nbsp;&nbsp;（1）如果退票发生在发票开具当月且您尚未进行税务认证抵扣的，您退回发票即可。
                </p>
                <p>
                  &nbsp;&nbsp;（2）如果您已就该发票进行税务认证抵扣，或者退票时间已超过开票日期所在当月的，您应向眸瑞公司提供开具红字发票的必要资料，如《开具红字增值税专用发票信息表》等。
                </p>
                <p>
                  &nbsp;&nbsp;（3）对于眸瑞公司尚未开具发票或已开具发票但尚未交付给您的退款申请，无需您提供发票相关资料。
                </p>
                <p>
                  若无法满足上述条件，则无法办理退款，后果由您自行承担，眸瑞公司不就此承担任何责任。在完成上述退票及开具红字发票流程后，眸瑞公司将在次月内按照您实际消费数额重新开具发票。
                </p>
              </li>
              <li>
                3.3 服务保障
                <p>
                  3.3.1 眸瑞公司向您提供 24小时×7
                  天的售后服务，协助您解答、处理使用老子云服务过程中遇到的问题。
                </p>
                <p>
                  3.3.2
                  眸瑞公司在签订相关服务协议的范围内，为您提供数据备份，保障数据可靠性，除此之外，您应根据自身需求进行数据备份。
                </p>
                <p>
                  3.3.3
                  眸瑞公司在签订相关服务协议范围内提供可用性保障。如果眸瑞公司未能满足您所购买服务对应的相关服务协议的服务保障，则眸瑞公司应当按照相关服务协议向您承担补偿责任。
                  眸瑞公司的补偿责任总额不超过眸瑞公司就违约服务向您收取的当次服务费用总额。
                </p>
                <p>
                  3.3.4
                  如果您对可用性的要求高于所签订的相关服务协议确定内容，则需要您主动对自身系统进行高可用性的设置，眸瑞公司将给与必要的协助。如果需要眸瑞公司配合做设计，由双方另行协商确认。
                </p>
              </li>
              <li>
                3.4 服务中止或终止
                <p>
                  3.4.1
                  为了向您提供更加完善的服务，眸瑞公司有权定期或不定期地对服务平台或相关设备进行检修、维护、升级等（统称“常规维护”），如因常规维护造成老子云服务在合理时间内中断或暂停的，眸瑞公司无需为此向您承担任何责任。
                  但是，眸瑞公司应当至少提前 24
                  小时，就常规维护事宜通知您。若因不可抗力、基础运营商过错等原因导致的非常规维护，眸瑞公司应及时通知您。
                </p>
                <p>
                  3.4.2
                  为保证服务的安全性和稳定性，眸瑞公司可能对您使用的机房、服务器、带宽、数据库等产品进行不定期的升级、迁移等，您应予以配合。当涉及重大变更（如机房迁移），眸瑞公司应当提前至少
                  30 天通知您。
                </p>
                <p>
                  3.4.3
                  如老子云服务到期或终止，对于您因使用老子云服务而存储在眸瑞公司服务器中的数据等任何信息，眸瑞公司将为您保留15天（简称“保留期限”）。
                  您应承担保留期限内产生的云服务费用（若有），并在保留期限届满前结清费用、完成全部数据的迁移。保留期限届满后，老子云服务系统将自动删除您的所有数据。
                </p>
                <p>
                  3.4.4
                  若您使用预付费的服务且在服务期限届满前单方要求终止合作的，您未使用的服务期限对应的费用将不予退还，但是您可以继续使用相关服务直至服务期限届满，本协议至服务期限届满时终止。
                </p>
                <p>
                  3.4.5
                  眸瑞公司有权根据自身运营安排，随时调整、终止部分服务（包括但不限于对服务进行升级、整合等）。但是，眸瑞公司应提前至少30天通知您，以便您做好相关数据的转移备份以及业务调整等，以保护您的合法权益。
                </p>
              </li>
              <li>
                3.5 第三方产品或服务
                <p>
                  3.5.1
                  如果您通过老子云服务获取、使用第三方提供的任何产品或服务（包括但不限于老子云服务市场中由服务商等第三方提供的产品、服务），您应当评估该产品或服务是否符合您要求。
                </p>
                <p>
                  3.5.2
                  第三方产品或服务的开通，可能需要您与第三方另行签订单独的服务协议，单独的服务协议可能以电子文档形式展示，也可能是独立的纸质文档，您可以根据自身情况决定是否接受服务协议及使用产品或服务。
                </p>
                <p>
                  3.5.3 您因使用第三方产品或服务产生的纠纷由您与第三方协商解决。
                </p>
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第四条 客户权利义务</li>
              <li>
                4.1
                您有权依照本协议约定使用您采购的老子云服务并获得眸瑞公司的技术支持和售后服务。
              </li>
              <li>
                4.2
                您在使用老子云服务时须遵守相关法律法规、规章制度，维护互联网秩序和安全；不得从事包括但不限于以下行为，也不得为任何违反法律法规的行为提供便利：
                <p>
                  4.2.1
                  实施危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视。
                </p>
                <p>
                  4.2.2
                  实施诈欺、虚伪不实或误导行为，或实施侵害他人知识产权等任何合法权益的行为，如“私服”、“外挂”等。
                </p>
                <p>
                  4.2.3
                  发布、传播垃圾邮件（SPAM）或包含危害国家秩序和安全、封建迷信、淫秽、色情、低俗等违法违规信息。
                </p>
                <p>
                  4.2.4
                  违反与老子云网络相联通之网络、设备或服务的操作规定；实施违法或未授权之接取、盗用、干扰或监测。
                </p>
                <p>
                  4.2.5
                  实施任何破坏或试图破坏网络安全的行为，包括但不限于以病毒、木马、恶意代码、钓鱼等方式，对网站、服务器进行恶意扫描、非法侵入系统、非法获取数据等。
                </p>
                <p>
                  4.2.6
                  实施任何改变或试图改变老子云服务提供的系统配置或破坏系统安全的行为；利用技术或其他手段破坏、扰乱老子云服务的运营或他人对老子云服务的使用；
                  以任何方式干扰或企图干扰眸瑞公司任何产品或任何部分、功能的正常运行，或者制作、发布、传播上述工具、方法等。
                </p>
                <p>
                  4.2.7 因从事包括但不限于“DNS
                  解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致您自己频繁遭受攻击（包括但不限于
                  DDoS 攻击）且未及时更正行为，
                  或未根据眸瑞公司要求消除影响，从而对老子云服务平台或他人产生影响的。
                </p>
                <p>
                  4.2.8 实施其他违法、违规行为，包括但不限于赌博等非法活动。
                </p>
              </li>
              <li>
                4.3
                您不应在老子云服务上安装、使用盗版软件等，并且您应按照国家有关规定对您使用的计算机信息系统采取安全保护措施，包括但不限于安装经国家许可的计算机信息系统安全专用产品等。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第五条 眸瑞公司权利义务</li>
              <li>
                5.1 眸瑞公司应当依照本协议约定向您提供老子云服务和售后支持。
              </li>
              <li>
                5.2
                眸瑞公司仅对老子云服务本身提供运营维护，您应当保证自身的网络、设备的安全性、稳定性，如发生以下情况，您应及时解决并避免对老子云服务产生影响：
                <p>5.2.1 您内部网络出现问题，包括但不限于超负荷等。</p>
                <p>5.2.2 您自有设备或您使用的第三方设备出现故障。</p>
                <p>5.2.3 您自行拆离设备或通过其他方式导致网络中断。</p>
                <p>5.2.4 其他您的原因导致的任何故障、网络中断等。</p>
              </li>
              <li>
                5.3
                若眸瑞公司自行发现或根据主管部门的信息、权利人的投诉等发现，您违反相关法律法规、规章制度或本协议的，眸瑞公司有权根据自己的独立判断单方采取以下措施中的一种或多种：
                <p>5.3.1 要求您立即删除、修改相关内容。</p>
                <p>5.3.2 直接删除、屏蔽相关内容或断开链接等。</p>
                <p>
                  5.3.3
                  限制、暂停向您提供老子云服务（包括但不限于直接对您的部分服务进行下线并收回相关资源、对您老子云账户进行操作限制等）。
                </p>
                <p>
                  5.3.4
                  情节严重的，眸瑞公司有权终止向您提供老子云服务，终止协议（包括但不限于直接对您的全部服务进行下线并收回相关资源等），您未使用的服务期限对应的费用将作为违约金归眸瑞公司所有。
                </p>
                <p>5.3.5 依法追究您的其他责任。</p>
              </li>
              <li>
                5.4
                眸瑞公司可将本协议部分或全部权利义务转让予第三方，但眸瑞公司须提前90天书面通知您。为本款生效之需要，双方同意签订所有合理必要的文件及采取合理必要的措施。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第六条 知识产权、保密及隐私</li>
              <li>
                6.1
                双方单独享有的商标权、著作权或者其他知识产权，均仍归各方单独享有，并不会因为双方签订或者履行本协议而转归对方享有，或者转归双方共同享有。
              </li>
              <li>
                6.2
                任何一方均应尊重相对方、第三方的知识产权，如有任何第三方就一方侵犯其知识产权等合法权益的原因向另一方提起诉讼、主张索赔的，
                责任方应当独立处理相关纠纷，赔偿另一方的直接经济损失，并使另一方完全免责。
              </li>
              <li>
                6.3
                任何一方（接收方）从另一方（披露方）所接受之信息，如有标明或可合理认知为属于披露方的机密或专有信息的(以下称“保密信息”)
                ，包括但不限于眸瑞公司向您提供的折扣优惠等未公开发布的内容等，
                接收方须对披露方的保密信息保密，且未经披露方书面同意，不得用于本协议以外目的。接收方应以对待其自身保密信息相同的注意程度（且不得低于合理审慎义务）处理披露方的保密信息。
              </li>
              <li>
                6.4
                未经您授权，眸瑞公司不得访问您存储在老子云中的内容。但是，眸瑞公司可以在事先获得您授权的前提下，访问您的存储内容，以便您顺利使用老子云服务。
              </li>
              <li>
                6.5 尽管如上所述，遇下列情况，接收方无需承担保密义务：
                <p>6.5.1 经披露方同意披露的。</p>
                <p>6.5.2 非因接收方的过失而导致众所周知。</p>
                <p>
                  6.5.3
                  接收方在披露方披露之前已由其他合法渠道获知，且披露方无类似保密限制的。
                </p>
                <p>
                  6.5.4 接收方因法律程序或主管机关的要求需要披露任何信息的。
                </p>
              </li>
              <li>
                6.6
                双方保密义务在本协议有效期限内及期限届满后持续有效，直至相关信息不再具有保密意义。
              </li>
              <li>
                6.7
                眸瑞公司有权根据国家司法、行政等主管部门的要求，配合查询、提供您信息等，以便及时解决投诉纠纷，保护各方合法权益。
              </li>
              <li>
                6.8
                为合理保护您、您的用户及权利人等各方的利益，眸瑞公司有权制定专门的侵权、投诉流程制度，您应当予以遵守。如果眸瑞公司接到第三方对您的投诉或举报，眸瑞公司有权向投诉方披露您的必要信息（包括但不限于注册名称、身份证明、联系人、联系电话等），
                并督促您与投诉方进行协商，以便及时解决投诉、纠纷，保护各方合法权益，您应当予以配合，否则，将可能影响您继续使用老子云服务。
              </li>
              <li>
                6.9
                《老子云隐私声明》仅适用于您使用本服务时产生的信息，不适用您在老子云存储的数据。眸瑞公司会按照公布的隐私声明的规定使用和披露相关信息。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第七条 责任限制</li>
              <li>
                7.1
                您理解并同意，在使用老子云服务的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，眸瑞公司应及时与相关单位配合进行修复，但是由此给您造成的损失眸瑞公司将予以免责。
                <p>
                  7.1.1
                  不可抗力，包括但不限于自然灾害、政府行为、政策颁布调整、法律法规颁布调整、罢工、动乱。
                </p>
                <p>
                  7.1.2
                  基础运营商原因，包括但不限于电信部门技术调整、电信/电力线路被他人破坏、电信/电力部门对电信网络/电力资源进行安装、改造、维护。
                </p>
                <p>
                  7.1.3
                  网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏。
                </p>
                <p>
                  7.1.4
                  您通过非眸瑞公司授权的方式使用老子云服务，您操作不当或您的电脑软件、系统、硬件和通信线路出现故障。
                </p>
                <p>
                  7.1.5 其他非眸瑞公司过错、眸瑞公司无法控制或合理预见的情形。
                </p>
              </li>
              <li>
                7.2
                因不可抗力、基础运营商原因、网络安全事故或其他超出当事人可合理掌控范围的事件，造成本协议迟延履行或任何一方违约，双方均无需承担违约责任。但是，受影响一方应尽可能及时通知另一方。
                前述事件妨碍协议履行达 30 个自然日以上的，任一方可提前 15
                天书面通知对方终止协议。因本条款终止协议的，任何一方均无须承担违约责任。
              </li>
              <li>
                7.3
                您理解并同意，眸瑞公司的服务是按照现有技术和条件所能达到的现状提供的。眸瑞公司将尽最大努力确保服务的连贯性和安全性，但眸瑞公司不能保证其所提供的服务毫无瑕疵。
                所以您也同意，即使眸瑞公司提供的服务存在瑕疵，但若上述瑕疵是当时行业技术水平所无法避免的，其将不被视为眸瑞公司违约，双方应友好协作共同解决问题。
              </li>
              <li>
                7.4
                在任何情况下，任何一方均不对相对方任何间接性、偶然性、特殊性的损害和损失，包括但不限于可得利益损失、相对方向第三方支付的费用等承担责任（即使该方已经被告知该等损失的可能性）。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第八条 通知和送达</li>
              <li>
                8.1
                您应当保证和维持资料的有效性，您的资料若存在虚假、无效等任何可能导致您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，由您自行承担相应责任。
              </li>
              <li>
                8.2
                您应当根据老子云官网公布的眸瑞公司的联系方式向眸瑞公司发送通知，双方另有约定除外。
              </li>
              <li>
                8.3
                眸瑞公司可以不定期以网页公告、电子邮件、手机短信、站内信、即时通讯工具等方式中的1种或多种向您发送与老子云服务有关的业务通知、服务提示、验证消息等各种业务通知，以及营销广告。
              </li>
              <li>
                8.4
                各方均应保证其联系方式真实、有效，通知自发送之日视为已送达收件人。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第九条 期限</li>
              <li>
                9.1
                双方合作期限自您点击同意接受本协议当天起至点击确认当年最后一日止，比如
                2016 年 6 月 1 日至 2016 年 12 月 31
                日。合作期限届满前任何一方均未书面提出到期不续约的要求的，双方合作期限将自动顺延
                1 年，顺延次数不限。
              </li>
              <li>
                9.2
                若双方合作期限与您选购的服务的期限不一致的，则双方合作期限自动顺延至您选购的服务的服务期限届满之日。除非双方另有约定，本协议在您使用老子云服务期间持续有效。
              </li>
              <li>
                9.3
                双方合作期限届满前，若任何一方书面向对方提出到期不续约的要求的，本协议在合作期限届满后自动终止。
              </li>
              <li>
                9.4 本协议的到期或终止，不影响协议到期或终止前产生的权利义务。
              </li>
            </ul>
            <ul class="ct">
              <li class="tit">第十条 附则</li>
              <li>10.1 本协议的签订地为湖南省长沙市雨花区。</li>
              <li>
                10.2
                本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
              </li>
              <li>
                10.3
                因本协议产生之争议，双方应首先协商解决；双方未能以诚意协商解决的，任何一方均应将纠纷或争议提交长沙市雨花区人民法院管辖。
              </li>
              <li>
                10.4
                本协议的拟定、解释均以中文为准。除双方另有约定外，任何有关本协议的翻译不得作为解释本协议或判定双方当事人意图之依据。
              </li>
            </ul>
          </div>
          <div class="btn">
            <el-button round class="btn-blue-opacity" @click="close"
              >取消</el-button
            >
            <el-button
              round
              class="btn-blue"
              @click="agree"
              style="margin-left:30px;"
              >阅读并同意</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import Cookie from "js-cookie";

export default {
  data() {
    return {
      //   dialogVisible: true
    };
  },
  computed: {
    ...mapState("login", {
      path: (state) => state.agreementPath,
    }),
  },
  created() {},
  watch: {
    "$root.agreeVisible": function(val) {
      console.log(val);
      this.$nextTick(() => {
        if (val == true && this.$refs.ctBox) {
          this.$refs.ctBox.onwheel = (e) => {
            e.stopPropagation();
          };
        }
      });
    },
    mounted() {},
  },
  methods: {
    agree() {
      this.$root.agreeVisible = false;
      this.$root.registVisible = true;
    },
    close() {
      this.$root.agreeVisible = false;
    //   if (Cookie.get("returnURL")) {
    //     location.href = Cookie.get("returnURL");
    //     Cookie.remove("returnURL");
    //   } else {
    //     // this.$router.push({ path: '/' })
    //     location.href =
    //       process.env.NODE_ENV == "test"
    //         ? "https://www.laozicloud.net/"
    //         : "https://www.laozicloud.com/";
    //   }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .box {
    width: 800px;
    background: #fff;
    // height: 700px;
    box-sizing: border-box;
    position: relative;
    .icon-guanbi {
      position: absolute;
      top: 10px;
      font-size: 18px;
      right: 10px;
      padding: 10px;
      color: #8192a8;
      cursor: pointer;
      &:hover {
        color: #0055f3;
      }
    }
    .login-another {
      margin-top: 40px;
      .t {
        color: #8192a8;
        font-size: 16px;
        text-align: center;
      }
      .l-icon {
        margin-top: 29px;
        .iconfont {
          cursor: pointer;
          width: 55px;
          height: 55px;
          display: inline-block;
          line-height: 55px;
          text-align: center;
          color: #fff;
          background: #8192a8;
          border-radius: 50%;
          font-size: 24px;
          &:first-child {
            margin-right: 40px;
            &:hover {
              background: #24db5a;
            }
          }
          &:first-child + i {
            &:hover {
              background: #1bc1fa;
            }
          }
        }
      }
    }
    .line {
      height: 1px;
      background: #e4e9f3;
      height: 1px;
      width: 320px;
      margin-top: 60px;
    }
    .helper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      width: 320px;
      margin-top: 15px;
      font-size: 16px;
      .left {
        color: #132c4b;
      }
      .right {
        color: #8192a8;
        cursor: pointer;
        span {
          &:hover {
            color: #409eff;
          }
        }
      }
    }
    .btn {
      padding-top: 30px;
      border-top: 1px solid #e4e9f3;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      button {
        width: 116px;
      }
      span {
        display: inline-block;
        width: 180px;
        height: 60px;
        border-radius: 40px;
        background-color: #9fbef8;
        text-align: center;
        line-height: 60px;
        color: #0055f3;
        font-size: 16px;
        cursor: pointer;
        &:first-child {
          margin-right: 20px;
        }
        &:first-child + span {
          background-color: #0055f3;
          color: #fff;
        }
      }
    }
    .ct-box {
      height: 400px;
      overflow: auto;
      margin-top: 20px;
      color: #333;
      font-size: 16px;
      line-height: 24px;
      padding-right: 15px;
      margin-bottom: 20px;
      ::-webkit-scrollbar {
        width: 16px;
        height: 16px;
        background-color: #f00;
      }
      li {
        margin-bottom: 20px;
        font-size: 14px;
        p {
          margin-top: 20px;
          color: #333;
          font-size: 14px;
          padding-left: 10px;
        }
      }
      .tit {
        color: #0055f3;
      }
    }
    .tab {
      text-align: center;
      border-bottom: 1px solid #e4e9f3;
      li {
        height: 27px;
        cursor: pointer;
        line-height: 27px;
        color: #182c49;
        font-size: 20px;
        padding-bottom: 30px;
        font-family: "微软雅黑";
        font-weight: bold;
      }
      //   .on {
      //     border-color: #0055f3;
      //   }
    }
  }
}
.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}
.btn-blue-opacity {
  border: 1px solid #1458ea;
  color: #1458ea;
}
.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}
/deep/ .el-dialog__header {
  display: none;
}
</style>
